// JsFromRoutes CacheKey ba928e8d3ed226fa65d90cd75508fb15
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/'),
}
